"use client";

import { SchoolData } from "@nimble/candidate-api/types";

import { withAuthGate } from "@/components/shared/auth-paywall/with-auth-gate";
import {
  ExpressInterestAlreadySubmittedContentView,
  ExpressInterestModalContentView,
} from "@/components/shared/buttons/express-interest-button/express-interest-modal/express-interest-modal-content.view";
import ExpressInterestModalSkeleton from "@/components/shared/buttons/express-interest-button/express-interest-modal/express-interest-modal-skeleton";
import { ActionRequirementsModalContentContainer } from "@/components/shared/dialogs/action-requirements-modal/action-requirements-modal.container";
import { ActionType } from "@/components/shared/dialogs/action-requirements-modal/action-requirements-modal-content.view";
import ActionRequirementsModalSkeleton from "@/components/shared/dialogs/action-requirements-modal/action-requirements-modal-skeleton";
import { withProfileCompletionGate } from "@/components/shared/gates/profile-completion-gate";
import { ProfileProgressTrackerModalContent } from "@/components/shared/profile-progress-tracker-header/profile-progress-tracker-modal";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { ProfileCompletionState } from "@/lib/profile-completion";
import { User } from "@/lib/types/auth";

const ExpressInterestAlreadySubmittedGuard = (props: {
  onClose: () => void;
  onSubmitSuccess: () => void;
  schoolData: SchoolData;
  user: User;
  isExpressedInterest?: boolean;
}) => {
  if (props.isExpressedInterest) {
    return (
      <ExpressInterestAlreadySubmittedContentView onClose={props.onClose} />
    );
  }
  return <ExpressInterestAuthorizedContentWithProfileGate {...props} />;
};

const ExpressInterestAuthorizedContentWithProfileGate =
  withProfileCompletionGate(ExpressInterestModalContentView, {
    minState: ProfileCompletionState.REQUIRES_MATCH_QUIZ,
    customLoader: <ExpressInterestModalSkeleton />,
    customGate: (_props, { profileCompletionState, verificationStatus }) => (
      <div className="p-0">
        <ProfileProgressTrackerModalContent
          state={profileCompletionState}
          verificationStatus={verificationStatus}
        />
      </div>
    ),
  });

const ExpressInterestModalContentWithAuthGate = withAuthGate(
  ExpressInterestAlreadySubmittedGuard,
  {
    customLoader: <ActionRequirementsModalSkeleton />,
    customPaywall: (props) => (
      <ActionRequirementsModalContentContainer
        schoolId={props.schoolData.nces_id}
        actionType={ActionType.ExpressInterest}
        onClose={props.onClose}
      />
    ),
  },
);

export default function ExpressInterestModal(props: {
  onClose: () => void;
  onSubmitSuccess: () => void;
  schoolData: SchoolData;
  isExpressedInterest?: boolean;
}) {
  return (
    <Dialog open onOpenChange={(open) => !open && props.onClose()}>
      <DialogContent
        showCloseButton={true}
        onClick={(event) => event.stopPropagation()}
        className="min-w-0 overflow-x-hidden p-0 gap-0"
      >
        <ExpressInterestModalContentWithAuthGate {...props} />
      </DialogContent>
    </Dialog>
  );
}
